import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaProjectDiagram, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import inforIcon from '../Images/SignUp/info.png';
import styles from '../Styles/SignUp';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import axios from 'axios';

const SignUp = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        contact: '',
        projectName: '',
        address: '',
        reason: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(API_ENDPOINTS.SendSignUpDetails, formData, {
                headers: authHeaders,
            });
            setSuccessMessage(response.data.message);
            setErrorMessage(''); // Clear any previous error messages
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrorMessage('There was an error sending your data. Please try again later.');
            setSuccessMessage(''); // Clear any previous success messages
        }
    };

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 style={styles.title}>Sign Up</h2>
                    <div style={styles.infoIcon}>
                        {/* Information icon with instructions */}
                        <img
                            src={inforIcon}
                            alt="Info Icon"
                            onMouseEnter={() => setTooltipVisible(true)}
                            onMouseLeave={() => setTooltipVisible(false)}
                            style={{ width: '25px', height: '25px' }} // Adjust size as needed
                        />
                        <div style={{ ...styles.tooltip, ...(tooltipVisible ? styles.tooltipVisible : {}) }}>
                            <ul style={styles.tooltipList}>
                                <li style={styles.tooltipListItem}>
                                    <span style={styles.bulletPoint}></span>
                                    We're glad you're interested in Vaculink.
                                </li>
                                <li style={styles.tooltipListItem}>
                                    <span style={styles.bulletPoint}></span>
                                    Please make sure to fill out all the required information and then click "Submit."
                                </li>
                                <li style={styles.tooltipListItem}>
                                    <span style={styles.bulletPoint}></span>
                                    Your login credentials will be sent to your email as soon as possible.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>First Name *</label>
                            <div style={styles.inputContainer}>
                                <div style={styles.iconContainer}><FaUser /></div>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                    style={styles.input}
                                    onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                                    onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                                />
                            </div>
                        </div>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>Last Name</label>
                            <div style={styles.inputContainer}>
                                <div style={styles.iconContainer}><FaUser /></div>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    style={styles.input} // No required attribute
                                    onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                                    onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Email ID *</label>
                        <div style={styles.inputContainer}>
                            <div style={styles.iconContainer}><FaEnvelope /></div>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                                onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                            />
                        </div>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Contact Number</label>
                        <div style={styles.inputContainer}>
                            <div style={styles.iconContainer}><FaPhone /></div>
                            <input
                                type="tel"
                                name="contact"
                                value={formData.contact}
                                onChange={handleChange}
                                style={styles.input} // No required attribute
                                onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                                onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                            />
                        </div>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Project Name *</label>
                        <div style={styles.inputContainer}>
                            <div style={styles.iconContainer}><FaProjectDiagram /></div>
                            <input
                                type="text"
                                name="projectName"
                                value={formData.projectName}
                                onChange={handleChange}
                                required
                                style={styles.input}
                                onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                                onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                            />
                        </div>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Address</label>
                        <div style={styles.inputContainer}>
                            <div style={styles.iconContainer}><FaMapMarkerAlt /></div>
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                style={styles.input} // No required attribute
                                onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                                onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                            />
                        </div>
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Message</label>
                        <textarea
                            name="reason"
                            value={formData.reason}
                            onChange={handleChange}
                            style={styles.textarea} // No required attribute
                            onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                            onBlur={(e) => (e.target.style.borderColor = '#ced4da')}
                        />
                    </div>
                    <button
                        type="submit"
                        style={{
                            ...styles.button,
                            ...(isHovered ? styles.buttonHover : {}),
                            ...(isActive ? styles.buttonActive : {})
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                    >
                        Submit
                    </button>
                </form>
                {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                <div style={styles.loginLink}>
                    <span style={styles.loginText}>Already have an account?</span>
                    <Link to="/login" style={styles.loginLinkText}>Login</Link>
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '15px', color: '#555', fontFamily: 'Arial, sans-serif',  }}>
                    <span>Vaculink 2.0r</span>
                </div>
            </div>
        </div>
    );
};

export default SignUp;
